import {FormHelperText} from '@mui/material';
import React from 'react';
import {Controller, ControllerProps, FieldPath, FieldValues, RegisterOptions, ValidationRule} from 'react-hook-form';
import AppDatePicker, {AppDatePickerProps} from './AppDatePicker';

export type AppControlledDatePickerProps<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<AppDatePickerProps, 'name' | 'required'> &
    Omit<ControllerProps<TFieldValues, TName>, 'render'> & {
        required?: string | ValidationRule<boolean>;
        label: string | React.ReactNode;
        errorMessage?: string;
    };

export function AppControlledDatePicker<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
    name,
    control,
    rules,
    onChange,
    required,
    label,
    errorMessage,
    ...rest
}: AppControlledDatePickerProps<TFieldValues, TName>) {
    const customeRules: Omit<
        RegisterOptions<TFieldValues, TName>,
        'disabled' | 'valueAsNumber' | 'valueAsDate' | 'setValueAs'
    > = rules ? rules : {required: required ? `${label} is required` : false};
    return (
        <Controller
            name={name}
            rules={customeRules}
            control={control}
            render={({field, fieldState: {invalid, error}}) => {
                return (
                    <>
                        <AppDatePicker
                            label={label}
                            required={!!required}
                            {...rest}
                            {...field}
                            value={field.value ? new Date(field.value) : null}
                            defaultValue={null}
                            onChange={(e, context) => {
                                if (onChange) {
                                    onChange(e, context);
                                }
                                field.onChange(e?.toISOString().split('T')[0]);
                            }}
                        />
                        <FormHelperText sx={{color: 'red'}}>{errorMessage ?? error?.message ?? ''}</FormHelperText>
                    </>
                );
            }}
        />
    );
}

export default AppControlledDatePicker;
